import TContext from "../context/TContext";
import * as React from "react";
import DecoratorUtils from "./DecoratorUtils";

/**
 * 自动注解监听TContext
 * @param Con TContext类型
 * @param propsName
 */
const AutoContext = (Con: TContext<any>, propsName: string) => {
    return DecoratorUtils.decorator((that: any, oldFunc: any) => {
        return (
            <Con.context.Consumer>
                {context => {
                    that[propsName] = context;
                    return oldFunc();
                }}
            </Con.context.Consumer>
        );
    });
};

export default AutoContext;
